// Mock data for Learn Overseas Careers page
export const LINKEDIN_URL = "https://www.linkedin.com/company/learn-overseas/posts/?feedView=all";
export const HR_EMAIL = "hr@learnoverseas.com";

export const benefits = [
  {
    id: 1,
    title: "Meaningful Impact",
    description: "Empower students to achieve their global dreams.",
    icon: "Users",
    bg: "bg-orange-100",
    iconColor: "text-orange-500",
  },
  {
    id: 2,
    title: "Growth & Learning",
    description: "Work, learn and grow with continuous support.",
    icon: "TrendingUp",
    bg: "bg-amber-100",
    iconColor: "text-amber-500",
  },
  {
    id: 3,
    title: "Global Environment",
    description: "Be part of a diverse team with a global mindset.",
    icon: "Globe2",
    bg: "bg-emerald-100",
    iconColor: "text-emerald-500",
  },
  {
    id: 4,
    title: "People First Culture",
    description: "A supportive, inclusive and people-first workplace.",
    icon: "Heart",
    bg: "bg-sky-100",
    iconColor: "text-sky-500",
  },
  {
    id: 5,
    title: "Work-Life Balance",
    description: "Flexible policies that help you thrive in and out of work.",
    icon: "Briefcase",
    bg: "bg-rose-100",
    iconColor: "text-rose-500",
  },
];

export const positions = [
  {
    id: 1,
    title: "Process Advisors",
    type: "Full-time",
    mode: "On-site",
    description:
      "Guide and support students throughout their application process with accuracy and care.",
    icon: "UsersRound",
    iconBg: "bg-orange-500",
    iconColor: "text-white",
  },
  {
    id: 2,
    title: "Student Advisors",
    type: "Full-time",
    mode: "On-site",
    description:
      "Counsel and assist students in choosing the right course and university for their goals.",
    icon: "GraduationCap",
    iconBg: "bg-amber-400",
    iconColor: "text-white",
  },
  {
    id: 3,
    title: "Finance / Accounts",
    type: "Full-time",
    mode: "On-site",
    description:
      "Manage financial operations, ensure compliance and maintain accurate records.",
    icon: "CircleDollarSign",
    iconBg: "bg-emerald-400",
    iconColor: "text-white",
  },
  {
    id: 4,
    title: "Education Loan Advisor",
    type: "Full-time",
    mode: "On-site",
    description:
      "Help students explore and secure the best education loan options.",
    icon: "BookOpen",
    iconBg: "bg-sky-400",
    iconColor: "text-white",
  },
  {
    id: 5,
    title: "Counselors (Overseas)",
    type: "Full-time",
    mode: "On-site",
    description:
      "Support students overseas with their queries and ensure a smooth experience.",
    icon: "HandHeart",
    iconBg: "bg-stone-300",
    iconColor: "text-stone-700",
  },
  {
    id: 6,
    title: "Senior Counselors (Overseas)",
    type: "Full-time",
    mode: "On-site",
    description:
      "Lead and mentor students overseas and guide them at every step of their journey.",
    icon: "Star",
    iconBg: "bg-orange-500",
    iconColor: "text-white",
  },
];

export const stats = [
  { id: 1, value: "10K+", label: "Students Guided", icon: "Users" },
  { id: 2, value: "500+", label: "Partner Universities", icon: "Building2" },
  { id: 3, value: "15+", label: "Countries", icon: "Globe" },
  { id: 4, value: "200+", label: "Team Members", icon: "UsersRound" },
];
